import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import {
  EdsData,
  SalesStopData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { ItemListViewItemCard } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemListViewItemCard/ItemListViewItemCard";
import { getMediaItemBadges } from "@coworker/apprestructured/src/media-maintenance/helpers/getMediaItemBadges";
import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import { MediaItemType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemType";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { useTranslation } from "@coworker/locales";

interface AggregatedItemsListViewProps {
  article: AggregatedArticle;
  media: Media;
  hasOngoingTasks: boolean;
  mediaItemType?: MediaItemType;
  salesStopData?: SalesStopData | null;
  edsData?: EdsData | null;
  showActions?: boolean;
  selectArticleIdsMode?: boolean;
  isSelected?: boolean;
  handleSelectedItemChange?: () => void;
  itemCardRenderType?: ItemCardRenderType;
  itemInfo: Item | null;
  itemInfoLoading: boolean;
  badges4AK1?: string[];
  itemTags?: string[];
  stockInfo?: ItemStockInfo;
}

export const AggregatedItemListViewItem = ({
  article,
  media,
  hasOngoingTasks,
  mediaItemType = MediaItemType.REGULAR_ITEM,
  salesStopData,
  isSelected,
  edsData,
  showActions = true,
  selectArticleIdsMode = false,
  handleSelectedItemChange,
  itemCardRenderType = ItemCardRenderType.link,
  itemInfo,
  itemInfoLoading,
  badges4AK1 = [],
  itemTags = [],
  stockInfo,
}: AggregatedItemsListViewProps) => {
  const isItemInGroups = article.aggregatedArticles.some((a) => a.groupId);

  const { t } = useTranslation();
  const badges = getMediaItemBadges(
    article.id,
    article.aggregatedArticles.map((a) => a.id),
    t,
    hasOngoingTasks,
    salesStopData,
    media,
    true,
    badges4AK1,
    itemTags
  );

  mediaItemType = article.parentArticleCombinationNumber
    ? MediaItemType.LC_SUBITEM
    : mediaItemType;

  return (
    <div
      className={
        !showActions
          ? styles["item-card-root-row"]
          : styles["list-view-item-root"]
      }
    >
      <div
        className={
          !showActions
            ? styles["item-card-root-column"]
            : styles["list-view-item-root"]
        }
      >
        <ItemListViewItemCard<AggregatedArticle>
          edsData={edsData ?? null}
          mediaItemType={mediaItemType}
          showActions={showActions}
          itemCardRenderType={itemCardRenderType}
          isItemInGroups={isItemInGroups}
          badges={badges}
          article={article}
          media={media}
          mediaItemViewType={MediaItemViewType.AGGREGATED_ITEM_VIEW}
          itemInfo={itemInfo}
          stockInfo={stockInfo}
          itemInfoLoading={itemInfoLoading}
        />
      </div>
      {selectArticleIdsMode && !article.parentArticleCombinationNumber && (
        <div
          className={styles["select-item-checkbox"]}
          data-testid={`select-article-checkbox-aggregated`}
        >
          <FixaCheckbox
            id={article.id}
            value={article.id}
            checked={isSelected || false}
            onChange={handleSelectedItemChange || (() => {})}
          />
        </div>
      )}
    </div>
  );
};
